require('../../modules/es.reflect.apply');
var path = require('../../internals/path');

module.exports = path.Reflect.apply;
